import { object, SchemaOf } from 'yup';
import { validateEmail } from 'lib/utils/inputValidation';
import { ForgotPasswordFields, ForgotPasswordSchema } from './types';

export const forgotPasswordSchemaValidation: SchemaOf<ForgotPasswordSchema> = object().shape({
  [ForgotPasswordFields.email]: validateEmail.required('Email is required')
});
